var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoggingService as logger } from "@/logging/LoggingService";
import { getCmi5 } from "../cmi5Api/cmi5";
import { CourseStatusStatement } from "./CourseStatusStatement";
import { CMI5 } from "@/cmi5/cmi5Api/cmi5ModelIds";
export function sendCourseStatements(updatedCourseState) {
    return __awaiter(this, void 0, void 0, function* () {
        const launchMode = getCmi5().getLaunchMode();
        if (launchMode === CMI5.LAUNCH_MODE.NORMAL) {
            yield setSuccessState(updatedCourseState);
            yield setCompletionState(updatedCourseState);
            yield CourseStatusStatement.set(updatedCourseState.value);
        }
    });
}
function setSuccessState(updatedCourseState) {
    return __awaiter(this, void 0, void 0, function* () {
        const scoreRaw = updatedCourseState.value.score;
        const score = {
            scaled: scoreRaw / 100,
            raw: scoreRaw,
            min: 0,
            max: 100
        };
        if (updatedCourseState.changed.passed) {
            logger.debug("Set success state: passed");
            yield getCmi5().passed(score);
        }
        if (updatedCourseState.changed.failed) {
            logger.debug("Set success state: failed");
            yield getCmi5().failed(score);
        }
    });
}
function setCompletionState(updatedCourseState) {
    return __awaiter(this, void 0, void 0, function* () {
        if (updatedCourseState.changed.completed) {
            logger.debug("Set completion state: completed");
            yield getCmi5().completed();
        }
    });
}
